import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-area-footer',
  templateUrl: './public-area-footer.component.html',
  styleUrls: ['./public-area-footer.component.scss']
})
export class PublicAreaFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
